import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";
import { IncludedModifierType } from "src/app/shared/models/enums/IncludedModifierType.enum";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { IncludedModifierSelectOptions, OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";
import { OrderItem } from "src/app/shared/models/order";

@Component({
	selector: "app-kiosk-menu-item-selected",
	templateUrl: "./kiosk-menu-item-selected.component.html",
	styleUrls: ["../../../kiosk.styles.scss"],
})
export class KioskMenuItemSelectedComponent implements OnInit {
	@Input() canvasMenuItem: OOCanvasMenuItem;
	@Output() closeDialogEmitter = new EventEmitter<boolean>();

	orderItem: OrderItem;
	includedItemModifierCanvases: OOCanvas[] = [];
	includedItemOptions: {
		label: string;
		value: number;
	}[];
	itemDisplayPrice: number;

	modifierCanvases: OOCanvas;
	modifierSelectionModifiersSelected: any[];

	timestamp = new Date().valueOf();

	constructor(public kioskService: KioskService) {}

	ngOnInit(): void {
		this.orderItem = new OrderItem({
			menuItemKey: this.canvasMenuItem.menuItemKey,
			canvasKey: this.canvasMenuItem.canvasKey,
			name: this.canvasMenuItem.displayName || this.canvasMenuItem.ooMenuItem.name,
			price: this.kioskService.venueService.menuItemGetPriceFromNumber(this.canvasMenuItem.ooMenuItem, this.canvasMenuItem.priceNumber),
			quantity: 1,
			priceNumber: this.canvasMenuItem.priceNumber,
			modifiers: [],
		});

		this.itemDisplayPrice = this.kioskService.venueService.menuItemGetPriceFromNumber(this.canvasMenuItem.ooMenuItem, this.canvasMenuItem.priceNumber);

		this.canvasMenuItem.includedItemCanvases.forEach((includedModCanvas) => {
			includedModCanvas.menuItems.forEach((item) => {
				item.includedModifierSelectOptions = this.buildIncludedModifierSelectOptions(item);
				item.includedModifierSelectedDefault = item.includedModifierSelectOptions.find(
					(modItem) => modItem.includedModType === IncludedModifierType.NORMAL
				);
			});
		});
		console.log(this.orderItem);
	}

	buildIncludedModifierSelectOptions(item: OOCanvasMenuItem): IncludedModifierSelectOptions[] {
		const includedModsOptions = [];
		if (item.priceNumberNo) {
			includedModsOptions.push({
				includedModType: IncludedModifierType.NO,
				name: "No",
				value: item.priceNumberNo,
				menuItemKey: item.menuItemKey,
				canvasMenuItem: item,
				default: false,
			});
		}
		includedModsOptions.push({
			includedModType: IncludedModifierType.NORMAL,
			name: "As Is",
			value: item.priceNumber,
			menuItemKey: item.menuItemKey,
			canvasMenuItem: item,
			default: true,
		});
		if (item.priceNumberLite) {
			includedModsOptions.push({
				includedModType: IncludedModifierType.LITE,
				name: "Lite",
				value: item.priceNumberLite,
				menuItemKey: item.menuItemKey,
				canvasMenuItem: item,
				default: false,
			});
		}
		if (item.priceNumberExtra) {
			includedModsOptions.push({
				includedModType: IncludedModifierType.EXTRA,
				name: "Extra",
				value: item.priceNumberExtra,
				menuItemKey: item.menuItemKey,
				canvasMenuItem: item,
				default: false,
			});
		}

		return includedModsOptions;
	}

	calculateItem(selectedModItem: IncludedModifierSelectOptions) {
		if (
			this.orderItem.modifiers?.some(
				(modifier) => modifier.menuItemKey === selectedModItem.menuItemKey && modifier.canvasKey === selectedModItem.canvasMenuItem.canvasKey
			)
		) {
			this.orderItem.modifiers.splice(
				this.orderItem.modifiers.findIndex((modifier) => modifier.menuItemKey === selectedModItem.menuItemKey),
				1
			);
		}

		const modItem = new OrderItem({
			menuItemKey: selectedModItem.menuItemKey,
			canvasKey: selectedModItem.canvasMenuItem.canvasKey,
			price: this.kioskService.venueService.menuItemGetPriceFromNumber(selectedModItem.canvasMenuItem.ooMenuItem, selectedModItem.value),
			priceNumber: selectedModItem.value,
			priceNumberName: selectedModItem.name,
			kitchenComment: true,
			quantity: 1,
			name: `${selectedModItem.name} ${selectedModItem.canvasMenuItem.ooMenuItem.name}`,
		});
		this.orderItem.modifiers.push(modItem);

		this.calculateItemDisplayPrice();
	}

	calculateItemDisplayPrice() {
		let itemModifierPrice: number = 0;
		this.orderItem.modifiers.forEach((modifier) => {
			itemModifierPrice += modifier.price * modifier.quantity;
			console.log(modifier.price * modifier.quantity);
		});

		this.itemDisplayPrice = +(this.orderItem.price + itemModifierPrice).toFixed(2);
	}

	selectModifierOption(modifierSelected: any) {
		console.log(modifierSelected);
	}
}
